import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import { FormattedMessage } from "react-intl";
import {
  DEFAULT_PHONE_COUNTRY_CODE,
  emailPattern,
  numberPattern,
} from "../../../../constants";
import { PatientDetailsFormInputs } from "../../../../models/users.interface";
import ButtonGroupFormInput from "../../../Shared/ButtonGroup/ButtonGroupFormInput";
//import CheckBoxFormInput from "../../../Shared/CheckBox/CheckBoxFormInput";
import ConnectForm from "../../../Shared/ConnectForm/ConnectForm";
import DateFormInput from "../../../Shared/DateInput/DateFormInput";
import { FormWarning } from "@shltelemedicine/shl-ui-lib";
import TextFormInput from "../../../Shared/TextInput/TextFormInput";
import GenderSelectFormInput from "../GenderSelectFormInput/GenderSelectFormInput";
import CountryCodeSelect from "../../../Shared/CountryCodeSelect/CountryCodeSelect";
import { Controller } from "react-hook-form";
import { useEffect, useState } from "react";
import { getPhoneNumberLengthByCountryCode } from "../../../../utils/phoneUtil";

type PatientInfoInputsProps = {
  isEdit?: boolean;
  disabled?: boolean;
  defaultCountryCode?: string;
};
const PatientInfoInputs = ({
  isEdit,
  disabled,
  defaultCountryCode = DEFAULT_PHONE_COUNTRY_CODE,
}: PatientInfoInputsProps) => {
  const [requiredPhoneLength, setRequiredPhoneLength] = useState(0);
  useEffect(() => {
    defaultCountryCode &&
      setRequiredPhoneLength(
        getPhoneNumberLengthByCountryCode(defaultCountryCode)
      );
  }, [defaultCountryCode]);

  return (
    <ConnectForm<PatientDetailsFormInputs>>
      {({ control, formState: { errors: formErrors } }) => {
        const errorPlaceholder =
          formErrors?.firstName || formErrors?.lastName ? (
            <div
              className={` text-center font-sm flex-grow-1`}
              style={{
                color: "white",
                padding: "0.25rem",
                visibility: "hidden",
              }}
            >
              Placeholder
            </div>
          ) : (
            <></>
          );
        return (
          <>
            <Form.Row className="mb-2">
              <Form.Group as={Col} className="mb-0">
                <Form.Label className="mb-1 font-md d-flex align-items-center">
                  <span className="prim-color">*</span>
                  <span className="mx-sm">
                    <FormattedMessage
                      id="USER.FIRST_NAME"
                      defaultMessage="First Name"
                    />
                    :
                  </span>
                  <span className="mx-1"></span>
                  {!!formErrors?.firstName ? (
                    <FormWarning
                      className="font-sm flex-grow-1"
                      message={
                        <FormattedMessage
                          id="MANAGEMENT.ADD_USER.FIRST_NAME_REQUIRED"
                          defaultMessage="Insert First name"
                        />
                      }
                    />
                  ) : (
                    errorPlaceholder
                  )}
                </Form.Label>

                <TextFormInput
                  name={"firstName"}
                  control={control}
                  rules={{
                    required: true,
                  }}
                  input={{
                    isInvalid: !!formErrors?.firstName,
                    disabled: disabled,
                  }}
                />
              </Form.Group>
              <Form.Group as={Col} className="mb-0">
                <Form.Label className="mb-1 d-flex font-md">
                  <span className="prim-color">*</span>
                  <span className="mx-sm">
                    <FormattedMessage
                      id="USER.LAST_NAME"
                      defaultMessage="Last Name"
                    />
                    :
                  </span>
                  <span className="mx-1"></span>
                  {!!formErrors?.lastName ? (
                    <FormWarning
                      className="font-sm flex-grow-1"
                      message={
                        <FormattedMessage
                          id="MANAGEMENT.ADD_USER.LAST_NAME_REQUIRED"
                          defaultMessage="Insert Last name"
                        />
                      }
                    />
                  ) : (
                    errorPlaceholder
                  )}
                </Form.Label>

                <TextFormInput
                  name={"lastName"}
                  control={control}
                  rules={{
                    required: true,
                  }}
                  input={{
                    isInvalid: !!formErrors?.lastName,
                    disabled: disabled,
                  }}
                />
              </Form.Group>
            </Form.Row>
            <Form.Row className="mb-2">
              <Form.Group as={Col} sm={12} md={6} className="mb-0">
                <Form.Label className="mb-1 d-flex font-md">
                  {/* <span className="prim-color">*</span>{" "} */}
                  <FormattedMessage id="USER.GENDER" defaultMessage="Gender" />:
                  {!!formErrors?.gender ? (
                    <FormWarning
                      className="font-sm flex-grow-1"
                      message={
                        <FormattedMessage
                          id="MANAGEMENT.ADD_USER.GENDER_REQUIRED"
                          defaultMessage="Select Gender"
                        />
                      }
                    />
                  ) : (
                    errorPlaceholder
                  )}
                </Form.Label>

                <GenderSelectFormInput
                  // required
                  control={control}
                  disabled={disabled}
                  isInvalid={!!formErrors?.gender}
                />
              </Form.Group>
              <Form.Group as={Col} sm={12} md={6} className="mb-0">
                <Form.Label className="mb-1 font-md">
                  <FormattedMessage
                    id="USER.DATE_OF_BIRTH"
                    defaultMessage="Date of Birth"
                  />
                  :
                </Form.Label>

                <DateFormInput
                  name={"dateOfBirth"}
                  control={control}
                  input={{
                    isInvalid: !!formErrors?.dateOfBirth,
                    max: new Date(),
                    isClearable: false,
                    disabled: disabled,
                  }}
                />
              </Form.Group>
            </Form.Row>
            <Form.Row>
              <Form.Group as={Col} className="mb-2">
                <Form.Label className="mb-1 font-md">
                  <FormattedMessage
                    id="USER.BELT_SIZE"
                    defaultMessage="Belt Size"
                  />
                  :
                </Form.Label>
                <br />
                <ButtonGroupFormInput
                  name={"beltSize"}
                  control={control}
                  input={{
                    disabled: disabled,
                    items: [
                      { key: "S", value: "S" },
                      { key: "M", value: "M" },
                      { key: "L", value: "L" },
                      { key: "XL", value: "XL" },
                    ],
                  }}
                />
              </Form.Group>

              <Form.Group as={Col} className="mb-2">
                <Form.Label className="mb-1 font-md">
                  <FormattedMessage
                    id="USER.PACEMAKER"
                    defaultMessage="Have Pacemaker?"
                  />
                  :
                </Form.Label>
                <br />
                <ButtonGroupFormInput
                  name={"hasPacemaker"}
                  control={control}
                  input={{
                    disabled: disabled,
                    items: [
                      { key: "true", value: "Yes" },
                      { key: "false", value: "No" },
                    ],
                  }}
                />
              </Form.Group>
            </Form.Row>
            <Form.Row className="mb-3">
              <Col xs={7}>
                <div className="d-flex mb-1">
                  <span className="prim-color">*</span>
                  <span className="mx-sm">
                    <Form.Label className="mb-1 font-md">
                      <FormattedMessage
                        id="USER.EMAIL"
                        defaultMessage="Email"
                      />
                      :
                    </Form.Label>
                  </span>
                  <span className="mx-1"></span>
                </div>

                <TextFormInput
                  name={"email"}
                  control={control}
                  rules={{
                    required: true,
                    pattern: emailPattern,
                  }}
                  input={{
                    isInvalid: !!formErrors?.email,
                    disabled: isEdit || disabled,
                    readOnly: isEdit,
                  }}
                />
                {!!formErrors?.email && (
                  <FormWarning
                    className="font-sm flex-grow-1"
                    message={
                      <FormattedMessage
                        id={`${
                          formErrors?.email?.type === "pattern"
                            ? "MANAGEMENT.ADD_USER.EMAIL_PATTERN_REQUIRED"
                            : "MANAGEMENT.ADD_USER.EMAIL_REQUIRED"
                        }`}
                        defaultMessage={`${
                          formErrors?.email?.type === "pattern"
                            ? "Insert Valid Email"
                            : "Insert Email"
                        }`}
                      />
                    }
                  />
                )}
              </Col>
              <Col xs={5}>
                <div className="d-flex mb-1">
                  <span className="mx-sm">
                    <Form.Label className="mb-1 font-md">
                      <FormattedMessage
                        id="USER.PHONE"
                        defaultMessage="Phone"
                      />{" "}
                      {"("}
                      <FormattedMessage
                        id="USER.PHONE.DIGITS_ONLY"
                        defaultMessage="Digits Only"
                      />
                      {")"}:
                    </Form.Label>
                  </span>
                  <span className="mx-1"></span>
                </div>
                {/* <div style={{ display: "flex" }}> 
                    <Controller
                    name="countryCode"
                    control={control}
                    render={({ field }) => (
                      <CountryCodeSelect
                        setValueOnChange={(countryDetails) => {
                          field.onChange(countryDetails.phoneCode);
                          setRequiredPhoneLength(
                            countryDetails.phoneNumberLength
                          );
                        }}
                        defaultPhoneCode={defaultCountryCode}
                      />
                    )}
                  ></Controller> */}
                <TextFormInput
                  name={"phone"}
                  control={control}
                  rules={{
                    pattern: numberPattern,
                    minLength: 5, //requiredPhoneLength,
                    // maxLength: requiredPhoneLength,
                  }}
                  input={{
                    isInvalid: !!formErrors?.phone,
                    disabled: disabled,
                  }}
                />
                {!!formErrors?.phone && (
                  <FormWarning
                    className="font-sm flex-grow-1"
                    message={
                      <FormattedMessage
                        id="MANAGEMENT.ADD_USER.PHONE_PATTERN_REQUIRED"
                        defaultMessage="Insert Digits Only"
                      />
                    }
                  />
                )}
                {/* </div> */}
              </Col>
            </Form.Row>

            {/*TODO: uncomment when email verification flow is ready*/}
            {/* <Form.Row>
              <Form.Group as={Col} className="mb-0">
                <CheckBoxFormInput
                  name={"emailVerificationRequired"}
                  control={control}
                  input={{
                    label: (
                      <FormattedMessage
                        id="PATIENT.EMAIL_VERIFICATION_REQUIRED"
                        defaultMessage="Email verification required"
                      />
                    ),
                  }}
                />
              </Form.Group>
              <Form.Group as={Col} className="mb-0 d-flex justify-content-end">
                <CheckBoxFormInput
                  name={"sendReportByEmail"}
                  control={control}
                  input={{
                    label: (
                      <FormattedMessage
                        id="PATIENT.SEND_REPORT_BY_EMAIL"
                        defaultMessage="Send report by email"
                      />
                    ),
                  }}
                />
              </Form.Group>
            </Form.Row> */}
          </>
        );
      }}
    </ConnectForm>
  );
};
export default PatientInfoInputs;
